<template>
  <div class="content-page">
    <div class="bd" :class="{ 'disable-event': isShowOrderDetails }">
      <div class="tab-header">
        <div class="header-left top">
          <div class="top-item">
            <span>筛选条件</span>
            <el-input
              placeholder="电话或订单号"
              v-model.trim="orderCondition"
              clearable
              size="small"
            ></el-input>
          </div>
          <!-- <div class="top-item" v-if="currentPage != '/order/takeout'">
            <span>手艺人</span>
            <el-select
              v-model="tablePositionValue"
              placeholder="请选择"
              size="small"
            >
              <el-option
                v-for="item in artisansList"
                :key="item.workUserId"
                :label="item.nickName"
                :value="item.workUserId"
              >
                <span
                  style="float: left;width:60px;overflow:hidden;text-overflow:ellipsis;"
                  >{{ item.nickName }}</span
                >
              </el-option>
            </el-select>
          </div> -->
          <div class="top-item">
            <span>时间选择</span>
            <el-date-picker
              v-model="orderTime"
              type="daterange"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
              size="small"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </div>
          <div class="top-item">
            <el-button type="primary" size="small" @click="screenOrder">筛选</el-button>
            <el-button @click="resetScreenData" size="small">重置</el-button>
            <el-button type="primary" @click="exportOrder" size="small"
              >导出订单</el-button
            >
          </div>
        </div>
        <div class="header-right">
          <el-button type="danger" size="small" @click="isShowWriteOff = true"
            >核销</el-button
          >
          <el-button type="primary" size="small" @click="openOrder">开单</el-button>
        </div>
      </div>
      <div class="tab-content">
        <el-tabs v-model="activeName" type="card" v-if="shopInfo.edcShopType != 5">
          <el-tab-pane
            v-for="item in orderClassifyList"
            :key="String(item.orderStatus)"
            :label="String(item.orderNum)"
            :name="String(item.orderStatus)"
          >
            <span slot="label">
              <span>{{ item.orderStatusName }}</span>
              <el-badge
                v-if="
                  item.orderNum &&
                  (item.orderStatus == -21 ||
                    item.orderStatus == 19 ||
                    item.orderStatus == 20 ||
                    item.orderStatus == 31)
                "
                :value="item.orderNum"
                class="item"
              ></el-badge>
            </span>
          </el-tab-pane>
        </el-tabs>
        <div class="list" v-loading="isLoad">
          <!-- <el-checkbox
            label="全选"
            v-if="activeName == 20"
            v-model="totalClick"
            @change="totalChecked"
          ></el-checkbox> -->
          <div class="order-list" v-if="orderList.length">
            <ul>
              <li v-for="(item, index) in orderList" :key="item.tradeNo">
                <div class="item">
                  <div class="list-header">
                    <div class="list-header-left">
                      <span v-if="activeName == 20"
                        ><el-checkbox
                          style="width: 20px"
                          @change="commidityClick(item, index)"
                          v-model="item.click"
                        ></el-checkbox
                      ></span>
                      <!-- <span class="order-num">#{{ item.orderNum }}</span> -->
                      <span class="delivery-time"
                        >下单时间：{{ item.supplementDateTime || item.createTime }}</span
                      >
                      <!-- <span class="suggest">建议12:19送达</span> -->
                      <span class="order-no">
                        订单号：{{ item.tradeNo }}
                        <input
                          style="position: absolute; top: 0; left: 0"
                          :value="item.tradeNo"
                          :class="`order-no${index}`"
                        />
                      </span>
                      <el-button type="text" @click="copyOrderNo(index)">复制</el-button>
                    </div>
                    <div class="list-header-right">
                      <el-button type="text" @click="orderInfo(item.mallOrderId)"
                        >订单详情</el-button
                      >
                    </div>
                  </div>
                  <div class="list-container">
                    <div class="products">
                      <template v-if="currentPage == '/order/equityCard'">
                        <div>
                          <div class="products-item">
                            <div class="info">
                              <img :src="''" alt v-if="shopInfo.edcShopType != 5" />
                              <div
                                :class="{
                                  'no-img': shopInfo.edcShopType == 5,
                                }"
                              >
                                <p class="name" :title="item.productSubject">
                                  {{ item.productSubject }}
                                </p>
                                <p class="price">
                                  ￥{{ Number(item.payMoney).toFixed(2) }}
                                </p>
                              </div>
                            </div>
                            <div class="num" v-if="shopInfo.edcShopType != 5">
                              {{ `X${1}` }}
                            </div>
                            <div class="price">
                              ￥{{ Number(item.payMoney).toFixed(2) }}
                            </div>
                            <div class="worker">
                              <template
                                v-for="work in item.workUserIds
                                  ? String(item.workUserIds).split(',')
                                  : []"
                              >
                                <p
                                  :key="work"
                                  v-if="
                                    work && mapArtisansList[work] && work != 'undefined'
                                  "
                                >
                                  手艺人:{{ mapArtisansList[work].nickName }}
                                </p>
                              </template>
                              <template
                                v-for="work in item.saleUserId
                                  ? String(item.saleUserId).split(',')
                                  : []"
                              >
                                <p
                                  :key="work"
                                  v-if="
                                    work && mapArtisansList[work] && work != 'undefined'
                                  "
                                >
                                  销售:{{ mapArtisansList[work].nickName }}
                                </p>
                              </template>
                            </div>
                            <div
                              class="action"
                              v-if="
                                item.orderCategory == 5 &&
                                item.orderStatus == 31 &&
                                productItem.productSaleStatus != 1 &&
                                productItem.productSaleStatus != 4 &&
                                shopInfo.edcShopType != 5
                              "
                            >
                              <el-dropdown
                                @command="
                                  handleEdit($event, index, productIndex, itemIndex)
                                "
                              >
                                <span class="el-dropdown-link">
                                  编辑
                                  <i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                  <el-dropdown-item command="retreat"
                                    >退菜</el-dropdown-item
                                  >
                                  <el-dropdown-item command="give">赠送</el-dropdown-item>
                                </el-dropdown-menu>
                              </el-dropdown>
                            </div>
                            <div class="action" v-else></div>
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        <div
                          v-for="(product, productIndex) in item.productsOem"
                          :key="productIndex"
                        >
                          <div
                            class="products-item"
                            v-for="(productItem, itemIndex) in product"
                            :key="itemIndex"
                          >
                            <div class="info">
                              <img
                                :src="productItem.goodsImage"
                                alt
                                v-if="shopInfo.edcShopType != 5"
                              />
                              <div
                                :class="{
                                  'no-img': shopInfo.edcShopType == 5,
                                }"
                              >
                                <p class="name" :title="productItem.goodsName">
                                  {{ productItem.goodsName }}
                                </p>
                                <p
                                  class="desc"
                                  v-if="productItem.specDesc && shopInfo.edcShopType != 5"
                                  :title="productItem.specDesc"
                                >
                                  ({{ productItem.specDesc }})
                                </p>
                                <p class="price">
                                  ￥{{ Number(productItem.retailPrice).toFixed(2) }}
                                </p>
                              </div>
                            </div>
                            <div class="num" v-if="shopInfo.edcShopType != 5">
                              {{
                                productItem.unitType == 2
                                  ? `${productItem.qrcBuyCount}${productItem.goodsUnit}`
                                  : `X${productItem.buyCount}`
                              }}

                              <span
                                class="num-type"
                                :class="{
                                  retreat: productItem.productSaleStatus == 1,
                                  give: productItem.productSaleStatus == 4,
                                }"
                                v-if="
                                  productItem.productSaleStatus == 1 ||
                                  productItem.productSaleStatus == 4
                                "
                                >{{ productItem.productSaleStatus == 1 ? "退" : "赠"
                                }}{{ productItem.buyCount }}</span
                              >
                            </div>
                            <div class="price">
                              ￥{{ Number(productItem.totalTurnoverPrice).toFixed(2) }}
                            </div>
                            <div class="worker">
                              <template
                                v-for="work in productItem.workUserIds
                                  ? String(productItem.workUserIds).split(',')
                                  : []"
                              >
                                <p
                                  :key="work"
                                  v-if="
                                    work && mapArtisansList[work] && work != 'undefined'
                                  "
                                >
                                  手艺人:{{ mapArtisansList[work].nickName }}
                                </p>
                              </template>
                              <template
                                v-for="work in productItem.saleUserIds
                                  ? String(productItem.saleUserIds).split(',')
                                  : []"
                              >
                                <p
                                  :key="work"
                                  v-if="
                                    work && mapArtisansList[work] && work != 'undefined'
                                  "
                                >
                                  销售:{{ mapArtisansList[work].nickName }}
                                </p>
                              </template>
                            </div>
                            <div
                              class="action"
                              v-if="
                                item.orderCategory == 5 &&
                                item.orderStatus == 31 &&
                                productItem.productSaleStatus != 1 &&
                                productItem.productSaleStatus != 4 &&
                                shopInfo.edcShopType != 5
                              "
                            >
                              <el-dropdown
                                @command="
                                  handleEdit($event, index, productIndex, itemIndex)
                                "
                              >
                                <span class="el-dropdown-link">
                                  编辑
                                  <i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                  <el-dropdown-item command="retreat"
                                    >退菜</el-dropdown-item
                                  >
                                  <el-dropdown-item command="give">赠送</el-dropdown-item>
                                </el-dropdown-menu>
                              </el-dropdown>
                            </div>
                            <div class="action" v-else></div>
                          </div>
                        </div>
                      </template>
                    </div>
                    <div class="time">
                      <p>{{ item.buyerName || item.memberName }}</p>
                      <p>{{ item.buyerPhone }}</p>
                    </div>
                    <div class="price">
                      <p class="total-price">￥{{ item.payMoney }}</p>
                      <p v-if="item.payInterfacePartyType">
                        支付方式：
                        {{ payInterfacePartyTypes[item.payInterfacePartyType] }}
                      </p>
                      <!-- <p class="price-msg">
                        会员优惠：-￥{{ item.shopPromotionTotalPrice || 0 }}
                      </p>
                      <p class="price-msg">
                        优惠券：-￥{{ item.cashCouponTotalPrice || 0 }}
                      </p>
                      <p class="price-msg">
                        获取积分：{{ item.userScore || 0 }}
                      </p>
                      <p class="gain-money">
                        整单折后价：￥{{ item.gainMoney }}
                      </p>
                      <el-dropdown
                        @command="fullHandleEdit($event, index)"
                        v-if="
                          item.orderStatus == 31 ||
                            item.orderStatus == 10 ||
                            item.orderStatus == 40
                        "
                      >
                        <span class="el-dropdown-link">
                          修改价格
                          <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item
                            v-if="
                              item.orderStatus == 31 || item.orderStatus == 10
                            "
                            command="priceRevision"
                            >整单改价</el-dropdown-item
                          >
                          <el-dropdown-item
                            v-if="
                              item.orderStatus == 31 || item.orderStatus == 10
                            "
                            command="discount"
                            >整单打折</el-dropdown-item
                          >
                          <el-dropdown-item
                            v-if="item.orderStatus == 40"
                            command="refund"
                            >整单退款</el-dropdown-item
                          >
                        </el-dropdown-menu>
                      </el-dropdown> -->
                    </div>
                    <div class="action">
                      <p
                        v-if="orderType[item.orderStatus]"
                        :class="orderType[item.orderStatus].class"
                      >
                        {{ orderType[item.orderStatus].title }}
                      </p>
                      <p v-else>未知</p>
                      <!-- <p class="reason" v-if="item.peisongCancelReason">
                        {{ item.peisongCancelReason }}
                      </p>
                      <el-button
                        size="small"
                        type="primary"
                        v-if="orderType[item.orderStatus].btn"
                        @click="
                          handleOrder(
                            item.mallOrderId,
                            item.orderStatus,
                            item.totalRetailPrice,
                            item.entryType,
                            item
                          )
                        "
                        >{{ orderType[item.orderStatus].btn }}</el-button
                      >
                      <el-button
                        size="small"
                        type="primary"
                        class="create-btn"
                        plain
                        v-if="
                          item.orderStatus == -21 &&
                            currentPage == '/order/takeout'
                        "
                        @click="
                          handleOrder(
                            item.mallOrderId,
                            -22,
                            item.totalRetailPrice,
                            item.entryType
                          )
                        "
                        >拒绝退款</el-button
                      >

                      <el-button
                        size="small"
                        type="primary"
                        class="create-btn"
                        plain
                        v-if="
                          ((item.sendType != 5 &&
                            !item.eleStatus &&
                            item.orderStatus == 20) ||
                            (item.sendType == 5 && item.eleStatus == 99)) &&
                            item.isPickUp != 1
                        "
                        @click="showCargoWeightPop(item)"
                        >配送发单</el-button
                      >
                      <el-button
                        size="small"
                        type="danger"
                        class="create-btn"
                        plain
                        v-if="
                          (item.eleStatus &&
                            item.eleStatus <= 2 &&
                            item.sendType != 5 &&
                            item.isPickUp != 1) ||
                            (item.sendType == 5 &&
                              item.eleStatus == 0 &&
                              item.isPickUp != 1)
                        "
                        @click="
                          cancelOrder(shopInfo.sendType, item.mallOrderId)
                        "
                        >取消配送</el-button
                      >
                      <el-link
                        class="status-btn"
                        v-if="
                          ((item.sendType != 5 &&
                            item.eleStatus == 3 &&
                            item.orderStatus == 20) ||
                            (item.sendType == 5 && item.eleStatus == 30)) &&
                            item.isPickUp != 1
                        "
                        :underline="false"
                        type="success"
                        >此单已发送</el-link
                      >
                      <el-link
                        class="status-btn"
                        v-if="
                          (item.sendType != 5 &&
                            item.eleStatus == 5 &&
                            item.isPickUp != 1) ||
                            (item.sendType == 5 &&
                              item.eleStatus > 99 &&
                              item.isPickUp != 1)
                        "
                        :underline="false"
                        type="warning"
                        >已取消配送订单</el-link
                      >
                      <el-button
                        size="small"
                        type="primary"
                        v-if="item.orderStatus == -21"
                        @click="handleOrderFuc(item.mallOrderId, -50)"
                        >手动退款</el-button
                      > -->
                    </div>
                    <div class="print">
                      <el-button
                        size="small"
                        type="primary"
                        class="create-btn"
                        plain
                        v-if="item.orderStatus == 10"
                        @click="
                          linkTo(
                            `/home/my/order?orderType=${
                              currentPage == '/order/equityCard'
                                ? 'equityCard'
                                : 'openOrder'
                            }&mallOrderId=${item.mallOrderId}`
                          )
                        "
                        >收款</el-button
                      >
                      <el-button
                        size="small"
                        type="danger"
                        class="create-btn"
                        plain
                        v-if="item.orderStatus == 10"
                        @click="handleOrder(item.mallOrderId, 10)"
                        >取消订单</el-button
                      >
                      <el-button
                        size="small"
                        type="primary"
                        class="create-btn"
                        plain
                        v-if="item.orderStatus == 20"
                        @click="showCargoWeightPop(item)"
                        >发货</el-button
                      >
                      <el-button
                        size="small"
                        type="primary"
                        plain
                        v-show="item.orderStatus == 40"
                        @click="printOrder(item)"
                        >打印小票</el-button
                      >
                      <el-button
                        size="small"
                        type="danger"
                        v-if="
                          item.orderStatus == 40 && currentPage != '/order/equityCard'
                        "
                        @click="handleOrderFuc(item.mallOrderId, -50)"
                        >手动退款</el-button
                      >
                      <el-button
                        size="small"
                        type="danger"
                        v-if="
                          item.orderStatus == 40 && currentPage != '/order/equityCard'
                        "
                        @click="handleOrder(item.mallOrderId, 40)"
                        >原路返回</el-button
                      >
                      <el-button
                        v-show="item.orderStatus >= 30"
                        class="check-logistics"
                        size="small"
                        type="primary"
                        plain
                        @click="getLogisticsInfo(shopInfo.sendType, item.mallOrderId)"
                        >查看物流</el-button
                      >
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div v-else>
            <div class="list-none">
              <p>暂无更多数据</p>
            </div>
          </div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :current-page="pageNo"
            background
            layout="prev, pager, next, jumper"
            :total="pageCount"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="isShowDiscountPop" width="30%">
      <div class="dialog-body">
        <el-input
          placeholder="请输入折扣，如八折输入0.8"
          v-model="discount"
          @input="inputChangeLimitNum"
        ></el-input>
        <div class="tag-list">
          <div
            class="tag"
            :class="{
              sel: !!~tagSelList.indexOf(item.goodsCategoryId),
            }"
            v-for="item in tagList"
            :key="item.goodsCategoryId"
            @click="toggleSelType(item.goodsCategoryId)"
          >
            {{ item.categoryName }}
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowDiscountPop = false">取 消</el-button>
        <el-button type="primary" @click="discountConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="配送发单"
      :visible.sync="isShowCargoWeightPop"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="30%"
    >
      <div class="dialog-body">
        <el-input
          placeholder="请输入斤两"
          v-model="cargoWeight"
          @input="cargoWeightInput"
        ></el-input>
        <div class="dialog-row">
          <span>运费:</span>
          <span v-loading="isComputedFee"> {{ distributionFee }}元 </span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowCargoWeightPop = false">取 消</el-button>
        <el-button type="primary" @click="deliveryOrder">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="物流信息" :visible.sync="isShowLogisticsInfo" width="496px">
      <div class="logistics-dialog">
        <div class="logistics-header">
          <img class="icon" src="../assets/img/order/icon-ele.png" alt="" />
          <div class="info">
            <div class="name">
              骑手：<strong>{{ logisticsInfo.info.dmName }}</strong>
              <div class="tag">
                {{
                  logisticsInfo.info.sendType == 2
                    ? "达达"
                    : logisticsInfo.info.sendType == 3
                    ? "蜂鸟"
                    : logisticsInfo.info.sendType == 5
                    ? "美团"
                    : logisticsInfo.info.sendType == 6
                    ? "麦芽田"
                    : "闪送"
                }}
              </div>
            </div>
            <div class="phonenum">号码：{{ logisticsInfo.info.dmMobile }}</div>
          </div>
        </div>
        <div class="logistics-body">
          <div class="el-steps-oem">
            <div
              class="el-step-oem active"
              v-for="(item, index) in logisticsInfo.status"
              :key="item.id"
            >
              <div class="index">{{ logisticsInfo.status.length - index }}</div>
              <div
                class="title"
                :class="{
                  active:
                    logisticsInfo.status.length - index == logisticsInfo.status.length,
                }"
              >
                {{
                  logisticsInfo.info.sendType == 5
                    ? mtLogisticsInfoText[item.orderStatus].title
                    : logisticsInfo.info.sendType == 6
                    ? mytLogisticsInfoText[item.orderStatus].title
                    : logisticsInfoText[item.orderStatus].title
                }}
              </div>
              <div class="desc">
                {{
                  logisticsInfo.info.sendType == 5
                    ? mtLogisticsInfoText[item.orderStatus].desc
                    : logisticsInfo.info.sendType == 6
                    ? mytLogisticsInfoText[item.orderStatus].desc
                    : logisticsInfoText[item.orderStatus].desc
                }}
              </div>
              <div class="time">{{ item.modifyTime }}</div>
            </div>
          </div>
          <!-- <el-steps direction="vertical" :active="logisticsInfo.status.length">
            <el-step v-for="item in logisticsInfo.status" :key="item.id">
              <div slot="description">
                <div class="title">
                  {{ logisticsInfoText[item.orderStatus].title }}
                </div>
                <div class="desc">
                  {{ logisticsInfoText[item.orderStatus].desc }}
                </div>
                <div class="time">{{ item.modifyTime }}</div>
              </div>
            </el-step>
          </el-steps> -->
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="取消原因"
      :visible.sync="isShowDadaCancelReasons"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="500px"
    >
      <div class="dialog-body">
        <el-select v-model="dadaReason" placeholder="请选择取消原因" size="small">
          <el-option
            v-for="item in dadaCancelReasons"
            :key="item.id"
            :label="item.reason"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dadaCancelOrder">确 定</el-button>
      </span>
    </el-dialog>
    <div
      class="popup"
      v-if="orderDetails"
      :class="{
        show: isShowOrderDetails,
      }"
    >
      <div class="popup-content">
        <div class="popup-header">
          <span>订单详情</span>
          <img
            class="close"
            src="../assets/img/icon-close-dark.png"
            alt=""
            @click="isShowOrderDetails = false"
          />
        </div>
        <div class="popup-container">
          <div class="order-details">
            <div class="order-info">
              <div class="inline-block-title">订单详情</div>
              <div class="content">
                <p class="status">
                  {{
                    orderType[orderDetails.orderStatus]
                      ? orderType[orderDetails.orderStatus].title
                      : "未知"
                  }}
                </p>
                <div class="item">
                  <p><span>订单编号:</span>{{ orderDetails.tradeNo }}</p>
                  <p v-if="orderDetails.payTime">
                    <span>收款时间:</span>{{ orderDetails.payTime }}
                  </p>
                </div>
                <div class="item">
                  <p><span>下单时间:</span>{{ orderDetails.createTime }}</p>
                  <p v-if="orderDetails.finishTime">
                    <span>完成时间:</span>{{ orderDetails.finishTime }}
                  </p>
                </div>
                <div class="item">
                  <p><span>收银员:</span>{{ orderDetails.cashierFullName }}</p>
                </div>
                <div class="marks">客户备注: {{ orderDetails.buyerMark }}</div>
                <div class="marks" v-if="!isEditMarks">
                  商家备注: {{ orderDetails.orderMark }}
                </div>
                <el-input
                  type="textarea"
                  v-model="orderDetails.orderMark"
                  :rows="5"
                  v-if="isEditMarks"
                  @blur="saveMarksEdit"
                  @keyup.enter.native="saveMarksEdit"
                ></el-input>
                <el-button
                  type="primary"
                  plain
                  size="small"
                  v-if="!isEditMarks"
                  @click="isEditMarks = true"
                  >修改备注</el-button
                >
              </div>
            </div>
            <div class="buyer-info">
              <div class="inline-block-title">客户信息</div>
              <div class="content">
                <div class="buyer-details">
                  <img class="buyer-avatar" :src="orderDetails.headLogo" alt="" />
                  <span class="buyer-nickname">{{
                    orderDetails.memberName || orderDetails.buyerName
                  }}</span>
                </div>
                <div class="item">
                  <p v-if="orderDetails.buyerCode">
                    <span>客户编号:</span>{{ orderDetails.buyerCode }}
                  </p>
                  <p v-if="orderDetails.handCards">
                    <span>手牌号:</span>{{ orderDetails.handCards }}
                  </p>
                </div>
                <div class="item">
                  <p><span>联系电话:</span>{{ orderDetails.buyerPhone }}</p>
                  <p><span>性别:</span>{{ orderDetails.sex == 1 ? "男" : "女" }}</p>
                </div>
              </div>
            </div>
            <div class="consume-info">
              <div class="inline-block-title">商品详情</div>
              <div class="service-info">
                <div class="table">
                  <div class="table-header">
                    <div class="name">商品</div>
                    <div class="price">单价</div>
                    <div class="num">数量</div>
                    <div class="work">手艺人</div>
                    <div class="sale">销售</div>
                    <div class="promotion">商品优惠</div>
                    <div class="subtotal">小计</div>
                  </div>
                  <div class="table-body">
                    <div
                      class="item"
                      v-for="(productItem, productIndex) in orderDetails.products"
                      :key="productIndex"
                    >
                      <div class="name">
                        <img class="service-img" :src="productItem.goodsImage" alt />
                        <div class="service-details">
                          <p class="service-name" :title="productItem.goodsName">
                            {{ productItem.goodsName }}
                          </p>
                          <p
                            class="desc"
                            v-if="productItem.specDesc && shopInfo.edcShopType != 5"
                            :title="productItem.specDesc"
                          >
                            ({{ productItem.specDesc }})
                          </p>
                        </div>
                      </div>
                      <div class="price">
                        ￥{{
                          Number(
                            currentPage == "/order/equityCard"
                              ? orderDetails.totalTurnoverPrice
                              : productItem.retailPrice
                          ).toFixed(2)
                        }}
                      </div>
                      <div class="num">x{{ productItem.buyCount }}</div>
                      <div class="work">
                        <template
                          v-for="work in productItem.workUserIds
                            ? String(productItem.workUserIds).split(',')
                            : []"
                        >
                          <p
                            :key="work"
                            v-if="work && mapArtisansList[work] && work != 'undefined'"
                          >
                            {{ mapArtisansList[work].nickName }}
                          </p>
                        </template>
                        <p
                          v-if="
                            !productItem.workUserIds || !productItem.workUserIds.length
                          "
                        >
                          -
                        </p>
                      </div>
                      <div class="sale">
                        <template
                          v-for="work in currentPage == '/order/equityCard'
                            ? orderDetails.saleUserId
                              ? String(orderDetails.saleUserId).split(',')
                              : []
                            : productItem.saleUserIds
                            ? String(productItem.saleUserIds).split(',')
                            : []"
                        >
                          <p
                            :key="work"
                            v-if="work && mapArtisansList[work] && work != 'undefined'"
                          >
                            {{ mapArtisansList[work].nickName }}
                          </p>
                        </template>
                        <p
                          v-if="
                            currentPage == '/order/equityCard'
                              ? !orderDetails.saleUserId
                              : !productItem.saleUserIds ||
                                !productItem.saleUserIds.length
                          "
                        >
                          -
                        </p>
                      </div>
                      <div class="promotion">
                        {{
                          (currentPage == "/order/equityCard"
                            ? -1
                            : productItem.totalTurnoverPrice -
                              productItem.totalRetailPrice) > 0
                            ? "+"
                            : "-"
                        }}￥{{
                          Number(
                            currentPage == "/order/equityCard"
                              ? orderDetails.shopPromotionTotalPrice
                              : Math.abs(
                                  productItem.totalTurnoverPrice -
                                    productItem.totalRetailPrice
                                )
                          ).toFixed(2)
                        }}
                      </div>
                      <div class="subtotal">
                        ￥{{ Number(productItem.totalTurnoverPrice).toFixed(2) }}
                      </div>
                    </div>
                    <div class="total">
                      <p>
                        <span class="title"> 合计： </span>
                        <span class="price"> ￥{{ orderDetails.totalRetailPrice }} </span>
                      </p>
                      <p>
                        <span class="title"> 优惠： </span>
                        <span class="price">
                          {{
                            orderDetails.totalTurnoverPrice -
                              orderDetails.totalRetailPrice >
                            0
                              ? "+"
                              : "-"
                          }}￥{{
                            Number(
                              Math.abs(
                                orderDetails.totalTurnoverPrice -
                                  orderDetails.totalRetailPrice
                              )
                            ).toFixed(2)
                          }}
                        </span>
                      </p>
                      <p>
                        <span class="title">
                          付款：{{
                            payInterfacePartyTypes[orderDetails.payInterfacePartyType]
                          }}
                        </span>
                        <span class="price"> ￥{{ orderDetails.payMoney }} </span>
                      </p>
                      <p>
                        <span class="title"> 合计 </span>
                        <span class="price">
                          ￥{{ orderDetails.totalTurnoverPrice }}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="action">
            <el-button
              size="small"
              type="primary"
              class="create-btn"
              plain
              v-if="orderDetails.orderStatus == 10"
              @click="
                linkTo(
                  `/home/my/order?orderType=openOrder&mallOrderId=${orderDetails.mallOrderId}`
                )
              "
              >收款</el-button
            >
            <el-button
              size="small"
              type="danger"
              class="create-btn"
              plain
              v-if="orderDetails.orderStatus == 10"
              @click="handleOrder(orderDetails.mallOrderId, 10)"
              >取消订单</el-button
            >
            <el-button
              size="small"
              type="primary"
              class="create-btn"
              plain
              v-if="orderDetails.orderStatus == 20"
              @click="showCargoWeightPop(orderDetails)"
              >发货</el-button
            >
            <el-button
              size="small"
              type="primary"
              plain
              v-show="orderDetails.orderStatus == 40"
              @click="printOrder(orderDetails)"
              >打印小票</el-button
            >
            <el-button
              size="small"
              type="danger"
              v-if="orderDetails.orderStatus == 40 && currentPage != '/order/equityCard'"
              @click="handleOrderFuc(orderDetails.mallOrderId, -50)"
              >手动退款</el-button
            >
            <el-button
              size="small"
              type="danger"
              v-if="orderDetails.orderStatus == 40 && currentPage != '/order/equityCard'"
              @click="handleOrder(orderDetails.mallOrderId, 40)"
              >原路返回</el-button
            >
            <el-button
              v-show="orderDetails.orderStatus >= 30"
              class="check-logistics"
              size="small"
              type="primary"
              plain
              @click="getLogisticsInfo(shopInfo.sendType, orderDetails.mallOrderId)"
              >查看物流</el-button
            >
          </div>
        </div>
      </div>
    </div>

    <div
      class="popup write-off"
      :class="{
        show: isShowWriteOff,
      }"
    >
      <div class="popup-content">
        <div class="popup-header">
          <span>核销</span>
          <img
            class="close"
            src="../assets/img/icon-close-dark.png"
            alt=""
            @click="isShowWriteOff = false"
          />
        </div>
        <div class="popup-container">
          <div class="scan-pay">
            <img class="img-scan" src="@/assets/img/order/img-scan.png" alt="" />
            <p class="tips">使用扫码枪扫描客户的核销码</p>
          </div>
        </div>
      </div>
    </div>
    <div class="temp-main">
      <div class="temp-wrap">
        <form id="form1">
          <div class="title">{{ shopInfo.shopName }}</div>
          <p class="split-line">
            <span class="words"> 订单信息 </span>
            <span class="line" style="float: left"> </span>
            <span class="line" style="float: right"> </span>
          </p>
          <div class="two-columns">
            <div class="item">
              <span>订单编号：</span>
              <span>{{ printInfo.tradeNo }}</span>
            </div>
            <div class="item">
              <span>下单时间：</span>
              <span>{{ printInfo.supplementDateTime || printInfo.createTime }}</span>
            </div>
            <div class="item">
              <span>打印时间：</span>
              <span>{{ printInfo.printTime }}</span>
            </div>
            <div class="item">
              <span>顾客备注：</span>
              <span>{{ printInfo.buyerMark }}</span>
            </div>
            <div class="item">
              <span>商家备注：</span>
              <span>{{ printInfo.shopMark }}</span>
            </div>
          </div>
          <p class="split-line">
            <span class="words"> 消费明细 </span>
            <span class="line" style="float: left"> </span>
            <span class="line" style="float: right"> </span>
          </p>
          <div class="list-container">
            <div class="goods" v-for="(val, index) in printInfo.products" :key="index">
              <div class="goods-name font-bold mg-10">
                {{ index + 1 }}.{{ val.goodsName }}
              </div>
              <p class="spec mg-10 ti-10">{{ val.specDesc }}</p>
              <div class="two-columns" v-if="currentPage == '/order/service'">
                <div class="item ti-10">
                  <span>数量</span>
                  <span>x{{ val.buyCount }}</span>
                </div>
                <div class="item ti-10">
                  <span>原价</span>
                  <span>{{
                    (val.totalRetailPrice || val.totalTurnoverPrice).toFixed(2)
                  }}</span>
                </div>
                <div class="item ti-10">
                  <span>成交价</span>
                  <span>{{ val.totalTurnoverPrice.toFixed(2) }}</span>
                </div>
              </div>
              <div class="two-columns" v-if="currentPage == '/order/equityCard'">
                <div class="item ti-10">
                  <span>数量</span>
                  <span>x{{ val.buyCount }}</span>
                </div>
                <div class="item ti-10">
                  <span>单价</span>
                  <span>{{
                    (val.totalRetailPrice || val.totalTurnoverPrice).toFixed(2)
                  }}</span>
                </div>
              </div>
            </div>
            <div class="two-columns font-bold">
              <div class="item">
                <span>小计</span>
                <span>{{ printInfo.payMoney }}</span>
              </div>
            </div>
          </div>
          <p class="split-line" v-if="printInfo.memberWallet">
            <span class="words"> 会员信息 </span>
            <span class="line" style="float: left"> </span>
            <span class="line" style="float: right"> </span>
          </p>
          <div class="two-columns" v-if="printInfo.memberWallet">
            <div class="item">
              <span>会员号：</span>
              <span>{{ printInfo.memberName }}</span>
            </div>
            <div class="item">
              <span>手机号：</span>
              <span
                >{{ String(printInfo.buyerPhone).slice(0, 3) }}****{{
                  String(printInfo.buyerPhone).slice(
                    String(printInfo.buyerPhone).length - 4,
                    String(printInfo.buyerPhone).length
                  )
                }}</span
              >
            </div>
            <div class="item">
              <span>会员余额：</span>
              <span>{{ printInfo.memberWallet }}</span>
            </div>
            <div class="item">
              <span>会员积分：</span>
              <span>{{ printInfo.memberScore }}</span>
            </div>
          </div>
          <div class="order-info">
            <div class="two-columns">
              <div class="item font-bold mg-10">
                <span>商品合计</span>
                <span>{{ printInfo.totalRetailPrice }}</span>
              </div>
              <div class="item font-bold mg-10">
                <span>优惠合计</span>
                <span>{{ printInfo.shopPromotionTotalPrice }}</span>
              </div>
              <div class="two-columns">
                <div
                  class="item mg-10"
                  v-for="item in printInfo.shopPromotionDataList"
                  :key="item.name"
                >
                  <span>{{ item.name }}</span>
                  <span>{{ item.price > 0 ? "-" : "" }}{{ item.price }}</span>
                </div>
              </div>
              <div class="item mg-10">
                <span>支付方式</span>
                <span>{{ payInterfacePartyTypes[printInfo.payInterfacePartyType] }}</span>
              </div>
              <div class="item font-bold mg-10">
                <span>实际支付</span>
                <span>{{ printInfo.payMoney }}</span>
              </div>
            </div>
          </div>
          <div class="shop-info">
            <p class="mg-10">地址：{{ shopInfo.shopAddress }}</p>
            <p class="mg-10">联系电话：{{ shopInfo.linkTel }}</p>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getAllOrders,
  getShopTables,
  getOrderNumsByStatus,
  operateOrder,
  handleOrder,
  printOrder,
  createReundOrder,
  getEdcShopGoodsCategorys,
  getEleOrderShipDetail,
  getDeliveryStatusLogMYT,
  createEleOrder,
  manualIssuance,
  querySSDeliverFee,
  queryDDDeliverFee,
  addDDAfterQuery,
  addSSAfterQuery,
  cancelDadaOrder,
  getDadaCancelReasons,
  cancelShansongOrder,
  cancelEleOrder,
  orderCancelMYT,
  getDDOrderInfo,
  getDDlogistics,
  sendOrder,
  exportExcelOrderdetails,
  findArtisans,
  findShopWorks,
  setOrderAllMark,
  orderInfo,
  updateOrderStatusByOrderCode,
} from "@/api";
import takeoutPic from "@/assets/img/order/icon-takeout.png";
import tangPic from "@/assets/img/order/icon-tang.png";
import md5 from "js-md5";
import { mapState } from "vuex";
import request from "@/utils/request";
import { commonFuc } from "@/mixins/commonFuc";
import { getLodop } from "@/utils/LodopFuncs.js";

let params = null;
let orderList = null;

let cargoWeightInputTimer = null;

export default {
  mixins: [commonFuc],
  data() {
    return {
      takeoutPic: takeoutPic,
      tangPic: tangPic,
      pickupPic: require("@/assets/img/order/icon-pickup.png"),
      orderCondition: "",
      orderConditionPlaceholder: "",
      orderClassifyListBefore: [],
      orderClassifyList: [],
      activeName: "all",
      pageCount: 0,
      tablePositionValue: "all",
      tablePositionList: [
        {
          shoppingTableId: "all",
          tableName: "全部桌位",
        },
      ],
      orderCategory: "20",
      orderTime: [
        new Date(+new Date() - 3600 * 1000 * 24 * 29).pattern("yyyy-MM-dd"),
        new Date().pattern("yyyy-MM-dd"),
      ],
      startDate: new Date(+new Date() - 3600 * 1000 * 24 * 29).pattern("yyyy-MM-dd"),
      endDate: new Date().pattern("yyyy-MM-dd"),
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      pageNo: 1,
      pageSize: 5,
      orderList: [],
      isLoad: false,
      orderType: {
        10: {
          title: "待付款",
          class: "black",
        },
        // 19: {
        //   title: "待接单",
        //   class: "red",
        //   btn: "确认接单",
        // },
        20: {
          title: "待发货",
          class: "red",
          btn: "确认发货",
        },
        25: {
          title: "待到店消费",
          class: "black",
        },
        30: {
          title: "已发货",
          class: "black",
        },
        // 31: {
        //   title: "待买单",
        //   class: "black",
        //   btn: "确认买单",
        // },
        // 35: {
        //   title: "待评论",
        //   class: "black",
        //   // btn: "原路返回",
        // },
        40: {
          title: "已完成",
          class: "black",
          // btn: "原路返回",
        },
        "-10": {
          title: "已关闭",
          class: "red",
        },
        "-20": {
          title: "已取消",
          class: "red",
        },
        "-21": {
          title: "申请退款",
          class: "red",
          btn: "原路返回",
        },
        "-50": {
          title: "退款",
          class: "black",
        },
      },
      isShowDiscountPop: false,
      discount: "",
      tagList: [],
      tagSelList: [],
      //是否显示蜂鸟快递信息弹窗
      isShowLogisticsInfo: false,
      logisticsInfoText: {
        1: {
          title: "商家已接单",
          desc: "商家已接单，等待骑手接单",
        },
        2: {
          title: "骑士正在赶往店内取货",
          desc: "骑士正在赶往店内取货，请提前备好商品",
        },
        3: {
          title: "骑士正在送货",
          desc: "骑士正在努力赶往收货地点",
        },
        4: {
          title: "商品已送达，订单已完成",
          desc: "感谢您对码点餐的信任，期待再次光临",
        },
        5: {
          title: "骑手取消订单",
          desc: "骑手取消订单",
        },
        7: {
          title: "订单已过期",
          desc: "订单已过期",
        },
        8: {
          title: "指派单",
          desc: "指派单",
        },
        9: {
          title: "配送异常",
          desc: "配送异常，骑手返回途中",
        },
        10: {
          title: "骑士正在店内取货",
          desc: "骑士取货后，订单自动变成已发货状态",
        },
        1000: {
          title: "创建运单失败",
          desc: "创建运单失败",
        },
      },
      eleLogisticsInfoText: {
        1: {
          title: "商家已接单",
          desc: "商家已接单，等待骑手接单",
        },
        20: {
          title: "骑士正在赶往店内取货",
          desc: "骑士正在赶往店内取货，请提前备好商品",
        },
        2: {
          title: "骑士正在送货",
          desc: "骑士正在努力赶往收货地点",
        },
        3: {
          title: "商品已送达，订单已完成",
          desc: "感谢您对码点餐的信任，期待再次光临",
        },
        4: {
          title: "骑手取消订单",
          desc: "骑手取消订单",
        },
        7: {
          title: "订单已过期",
          desc: "订单已过期",
        },
        8: {
          title: "指派单",
          desc: "指派单",
        },
        5: {
          title: "配送异常",
          desc: "配送异常，骑手返回途中",
        },
        80: {
          title: "骑士正在店内取货",
          desc: "骑士取货后，订单自动变成已发货状态",
        },
        1000: {
          title: "创建运单失败",
          desc: "创建运单失败",
        },
        0: {
          title: "创建运单",
          desc: "创建运单",
        },
      },
      mtLogisticsInfoText: {
        20: {
          title: "商家已接单",
          desc: "商家已接单，等待骑手接单",
        },
        30: {
          title: "骑士正在送货",
          desc: "骑士正在努力赶往收货地点",
        },
        50: {
          title: "商品已送达，订单已完成",
          desc: "感谢您对码点餐的信任，期待再次光临",
        },
        99: {
          title: "骑手取消订单",
          desc: "骑手取消订单",
        },
        0: {
          title: "创建运单",
          desc: "创建运单",
        },
      },
      mytLogisticsInfoText: {
        20: {
          title: "骑士已抢单",
          desc: "骑士已抢单，赶往商家途中",
        },
        40: {
          title: "骑士正在送货",
          desc: "骑士正在努力赶往收货地点",
        },
        50: {
          title: "商品已送达，订单已完成",
          desc: "感谢您对码点餐的信任，期待再次光临",
        },
        30: {
          title: "骑士已到店",
          desc: "骑士已到店,等待出餐",
        },
        10: {
          title: "创建订单",
          desc: "已创建订单，等待骑士抢单",
        },
        99: {
          title: "骑手取消订单",
          desc: "骑手取消订单",
        },
        0: {
          title: "创建运单",
          desc: "创建运单",
        },
      },
      logisticsInfo: {
        info: {
          dmName: "毛晓松", //骑手姓名
          dmMobile: "13587435597", //骑手电话
          sendType: 2,
          delivery_party: "", //运力类型(汉字)
          delivery_longitude: "", //骑手经度
          delivery_latitude: "", //骑手纬度
        },
        status: [
          {
            mallOrderId: 11141,
            modifyTime: "2020-06-05 14:15:24",
            createTime: "2020-06-05 14:15:24",
            isDelete: 0,
            orderStatus: 1, ////订单状态(待接单＝1 待取货＝2 配送中＝3 已完成＝4 已取消＝5 已过期＝7 指派单=8 妥投异常之物品返回中=9  已到店=10（蜂鸟需要） 妥投异常之物品返回完成=10 创建达达运单失败=1000
            id: 79,
            isEnable: 1,
          },
          {
            mallOrderId: 11141,
            modifyTime: "2020-06-05 13:21:18",
            createTime: "2020-06-05 13:21:18",
            isDelete: 0,
            orderStatus: 5, //
            id: 77,
            isEnable: 1,
          },
          {
            mallOrderId: 11141,
            modifyTime: "2020-06-05 13:21:18",
            createTime: "2020-06-05 13:21:18",
            isDelete: 0,
            orderStatus: 5, //
            id: 77,
            isEnable: 1,
          },
          {
            mallOrderId: 11141,
            modifyTime: "2020-06-05 13:21:18",
            createTime: "2020-06-05 13:21:18",
            isDelete: 0,
            orderStatus: 5, //
            id: 77,
            isEnable: 1,
          },
          {
            mallOrderId: 11141,
            modifyTime: "2020-06-05 13:21:18",
            createTime: "2020-06-05 13:21:18",
            isDelete: 0,
            orderStatus: 5, //
            id: 77,
            isEnable: 1,
          },
          {
            mallOrderId: 11141,
            modifyTime: "2020-06-05 13:21:18",
            createTime: "2020-06-05 13:21:18",
            isDelete: 0,
            orderStatus: 5, //
            id: 77,
            isEnable: 1,
          },
          {
            mallOrderId: 11141,
            modifyTime: "2020-06-05 13:21:18",
            createTime: "2020-06-05 13:21:18",
            isDelete: 0,
            orderStatus: 5, //
            id: 77,
            isEnable: 1,
          },
        ],
      },
      isShowCargoWeightPop: false,
      cargoWeight: "",
      distributionFee: 0,
      isComputedFee: false,
      dadaCancelReasons: [],
      dadaReason: "",
      isShowDadaCancelReasons: false,
      dadaOrderId: "",
      totalClick: false,
      list: [],
      artisansList: [
        {
          nickName: "全部手艺人",
          workUserId: "",
        },
      ],
      mapArtisansList: {},

      isShowOrderDetails: false,
      orderDetails: null,
      isEditMarks: false,

      printInfo: {
        tradeNo: "ABC456789987",
        createTime: "2022-04-29 10:23:33",
        printTime: "2022-04-29 10:23:33",
        buyerMark: "加辣",
        shopMark: "加辣",
        products: [],
      },

      isShowWriteOff: false,
      orderCode: "",
    };
  },
  watch: {
    activeName(status) {
      this.orderClassifyList.forEach((val) => {
        if (val.orderStatus == status) {
          this.pageCount = val.orderNum;
        }
      });
      this.pageNo = 1;
      this.getPageData();
    },
    currentPage(v) {
      this.activeName = "all";
      this.getPageData();
    },
    orderTime(val) {
      if (val) {
        this.startDate = val ? new Date(val[0]).pattern("yyyy-MM-dd") : "";
        this.endDate = val ? new Date(val[1]).pattern("yyyy-MM-dd") : "";
      } else {
        this.startDate = "";
        this.endDate = "";
      }
      this.getPageData();
    },
    orderCondition(val) {
      if (!val.length) {
        this.getPageData();
      }
    },
    isShowDiscountPop(val) {
      if (!val) {
        this.discount = "";
        orderList = null;
        params = null;
      }
    },
    isShowWriteOff(val) {
      this.orderCode = "";
      if (val) {
        document.onkeydown = (e) => {
          console.log(e, "onkeydown");
          // var b;
          if (e.key == "Enter") {
            this.updateOrderStatusByOrderCode();
            // this.orderCode = "";
          }
          if (e.key != "Enter") {
            this.orderCode += e.key;
            // this.orderCode = "1652240780275414";
          }
        };
      } else {
        document.onkeydown = null;
      }
    },
  },
  computed: {
    ...mapState({
      shopInfo: (state) => state.shopInfo,
    }),
    currentPage() {
      console.log("currentPage");
      let path = this.$route.path;
      if (path == "/order/service") {
        this.orderCategory = "20";
      }
      if (path == "/order/takeout") {
        this.orderCategory = 3;
      }
      if (path == "/order/equityCard") {
        this.orderCategory = 19;
      }
      this.getOrderNumsByStatus();
      return path;
    },
  },
  mounted() {
    if (this.isDsType && this.$route.path == "/order") {
      this.$router.push({
        path: "/order/dsOrder",
        params: this.$route.params,
      });
    }
    if (this.$route.params.tradeNo) {
      this.orderCondition = this.$route.params.tradeNo;
    }
    if (this.$route.query.shoppingTableId) {
      this.tablePositionValue = Number(this.$route.query.shoppingTableId);
    }
    this.getShopTables();
    this.getPageData();
    this.getEdcShopGoodsCategorys();
    this.getDadaCancelReasons();
    this.findArtisans();
  },
  methods: {
    openOrder() {
      this.$router.push(`/home/my/order`);
    },
    updateOrderStatusByOrderCode() {
      updateOrderStatusByOrderCode({
        orderCode: this.orderCode,
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "核销成功",
            type: "success",
            duration: 1000,
          });
          if (this.isShowOrderDetails) {
            this.orderInfo(res.data.mallOrderId);
          }
          this.getPageData();
          this.isShowWriteOff = false;
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
        this.orderCode = "";
      });
    },
    getPageData() {
      this.getAllOrders();
    },
    findArtisans() {
      findArtisans({
        row: 99999,
      }).then((res) => {
        if (res.code == 1) {
          this.artisansList.push(...res.data);
          res.data.forEach((val) => {
            this.mapArtisansList[val.workUserId] = val;
          });
        }
        if (res.code == -1) {
          // this.mapArtisansList = {};
        }
      });
      findShopWorks({
        row: 99999,
        isAll: 1,
      }).then((res) => {
        if (res.code == 1) {
          res.data.forEach((val) => {
            val.nickName = val.fullName;
            val.workUserId = val.shopWorkerUserId;
            this.mapArtisansList[val.workUserId] = val;
          });
          this.artisansList.push(...res.data);
        }
        if (res.code == -1) {
        }
      });
    },
    getDadaCancelReasons() {
      getDadaCancelReasons().then((res) => {
        if (res.code == 1) {
          console.log(res);
          this.dadaCancelReasons = res.data;
        }
      });
    },
    getEdcShopGoodsCategorys() {
      getEdcShopGoodsCategorys({
        pageNo: this.pageNo,
        row: 9999,
      }).then((res) => {
        if (res.code == 1) {
          this.tagSelList = [];
          res.data.forEach((val) => {
            this.tagSelList.push(val.goodsCategoryId);
          });
          this.tagList = res.data;
        } else {
          this.tagList = [];
        }
      });
    },
    getOrderNumsByStatus(cb) {
      getOrderNumsByStatus({
        orderCategorys: this.orderCategory ? this.orderCategory : "3,5",
        // orderCategory: this.orderCategory,
        startDate: this.startDate,
        endDate: this.endDate,
        shoppingTableId: this.tablePositionValue == "all" ? "" : this.tablePositionValue,
        keyWord: this.orderCondition,
      }).then((res) => {
        if (res.code == 1) {
          this.orderClassifyListBefore = res.data;
          let path = this.$route.path;
          let list = [];
          let orderClassifyList = [];
          orderClassifyList = [
            {
              orderStatusName: "全部订单",
              orderNum: 0,
              orderStatus: "all",
            },
            {
              orderStatusName: "待付款",
              orderNum: 0,
              orderStatus: 10,
            },
            {
              orderStatusName: "待发货",
              orderNum: 0,
              orderStatus: 20,
            },
            {
              orderStatusName: "已发货",
              orderNum: 0,
              orderStatus: 30,
            },
            {
              orderStatusName: "待到店消费",
              orderNum: 0,
              orderStatus: 25,
            },
            {
              orderStatusName: "已完成",
              orderNum: 0,
              orderStatus: 40,
            },
            {
              orderStatusName: "已取消",
              orderNum: 0,
              orderStatus: -20,
            },
            {
              orderStatusName: "退款",
              orderNum: 0,
              orderStatus: -50,
            },
          ];
          if (this.currentPage == "/order/equityCard") {
            orderClassifyList = [
              {
                orderStatusName: "全部订单",
                orderNum: 0,
                orderStatus: "all",
              },
              {
                orderStatusName: "待付款",
                orderNum: 0,
                orderStatus: 10,
              },
              {
                orderStatusName: "已完成",
                orderNum: 0,
                orderStatus: 40,
              },
            ];
          }
          orderClassifyList.forEach((val) => {
            this.orderClassifyListBefore.forEach((subval) => {
              if (
                val.orderStatus == subval.orderStatus ||
                (subval.orderStatus == 0 && val.orderStatus == "all")
              ) {
                val.orderNum = subval.orderNum;
              }
            });
            list.push(val);
          });
          list.forEach((val) => {
            if (val.orderStatus == this.activeName) {
              this.pageCount = val.orderNum;
            }
          });
          this.orderClassifyList = list;
        }
      });
    },
    getAllOrders() {
      // console.log(this.activeName, "this.activeName")
      this.isLoad = true;
      this.orderList = [];
      getAllOrders({
        pageNo: this.pageNo,
        row: this.pageSize,
        orderStatus: this.activeName == "all" ? "" : this.activeName,
        orderCategorys: this.orderCategory ? this.orderCategory : "3,5",
        // orderCategory: this.orderCategory,
        shoppingTableId: this.tablePositionValue == "all" ? "" : this.tablePositionValue,
        startDate: this.startDate,
        endDate: this.endDate,
        keyWord: this.orderCondition,
      }).then((res) => {
        if (res.code == 1) {
          res.data.forEach((val, index) => {
            val.productsOem = [];
            val.products.forEach((proVal, proIndex) => {
              if (val.productsOem[proVal.groupId] == undefined) {
                val.productsOem[proVal.groupId] = [];
                val.productsOem[proVal.groupId].push(proVal);
              } else {
                val.productsOem[proVal.groupId].push(proVal);
              }
              if (proIndex == val.products.length - 1) {
                var r = val.productsOem.filter(function (s) {
                  return s;
                });
                val.productsOem = r;
                val.productsOem.reverse();
              }
            });
          });
          this.orderList = res.data;
          if (this.$route.params.tradeNo && this.orderCondition) {
            this.pageCount = res.data.length;
          }
        }
        if (res.code == -1) {
          this.orderList = [];
        }
        this.isLoad = false;
      });
    },
    getShopTables() {
      getShopTables({
        row: 1000,
      }).then((res) => {
        if (res.code == 1) {
          this.tablePositionList.push(...res.data);
        }
      });
    },
    resetScreenData() {
      this.pageNo = 1;
      this.tablePositionValue = "all";
      this.orderTime = [
        new Date(+new Date() - 3600 * 1000 * 24 * 29).pattern("yyyy-MM-dd"),
        new Date().pattern("yyyy-MM-dd"),
      ];
      this.startDate = new Date(+new Date() - 3600 * 1000 * 24 * 29).pattern(
        "yyyy-MM-dd"
      );
      this.endDate = new Date().pattern("yyyy-MM-dd");
      this.orderCondition = "";
      this.getPageData();
    },
    // 全选
    totalChecked() {
      console.log(this.orderList, "this.orderList");
      if (this.orderList.length == 0) {
        this.totalClick = false;
        return;
      }
      this.orderList.forEach((element) => {
        element.click = this.totalClick;
      });
      if (this.totalClick) {
        this.orderList.forEach((element) => {
          this.list.push(element);
          console.log(this.list, "全选");
        });
      } else {
        this.list = [];
        console.log(this.list, "全选");
      }
    },
    commidityClick(item, index) {
      console.log(item, index);
      var arr = this.orderList;
      console.log(item.click, "商品是否选中状态");
      if (item.click == false) {
        this.totalClick = false;
        for (let i in this.list) {
          if (this.list[i].mallOrderId == item.mallOrderId) {
            this.list.splice(i, 1);
          }
        }
        console.log(this.list, "false");
      } else {
        this.totalClick = arr.every((item1) => {
          return item1.click;
        });
        this.list.push(item);
        console.log(this.list, "true");
      }
      this.orderList = "";
      this.orderList = arr;
    },
    // 导出订单
    exportOrder() {
      console.log(this.startDate, this.endDate, this.orderCondition, "exportOrder");
      if (!this.startDate) {
        return this.$notify({
          title: "提示",
          message: "请选取开始时间",
          type: "error",
          duration: 1000,
        });
      }
      if (+new Date(this.endDate) - +new Date(this.startDate) > 3600 * 1000 * 24 * 30) {
        return this.$notify({
          title: "提示",
          message: "只能导出一个月内的订单",
          type: "error",
          duration: 1000,
        });
      }
      location.href = `${
        request.baseUrl
      }/edcmanageapi/Order_exportMeiyeOrderdetails?userId=${
        localStorage.userId
      }&sessionId=${localStorage.sessionId}&orderStatus=${
        this.activeName != "all" ? this.activeName : ""
      }&orderCategory=20&startDate=${this.startDate}&endDate=${this.endDate}&keyWord=${
        this.orderCondition
      }`;
    },
    // 批量发货
    batchDelivery() {
      console.log(this.list, "批量发货");
      if (this.list.length <= 0) {
        return;
      }
      var ids = "";
      this.list.forEach((ele) => {
        ids += ele.mallOrderId + ",";
      });
      if (ids.length > 0) {
        ids = ids.substr(0, ids.length - 1);
      }
      console.log(ids, "ids");
      // return
      sendOrder({
        mallOrderIds: ids,
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "操作成功",
            type: "success",
            duration: 1000,
          });
          this.list = [];
          this.getPageData();
          this.getOrderNumsByStatus();
        }
      });
    },
    screenOrder() {
      this.pageNo = 1;
      this.getPageData();
      this.getOrderNumsByStatus();
    },
    tabsChange(val) {},
    searchTable() {},
    handleSizeChange() {},
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getPageData();
    },
    handleEdit(e, index, productIndex, itemIndex) {
      //单个菜品的操作
      let params = {
        mallOrderId: this.orderList[index].mallOrderId,
      };
      params.products = JSON.parse(
        JSON.stringify(this.orderList[index].productsOem[productIndex][itemIndex])
      );
      if (params.products.unitType == 2) {
        this.$confirm(`请确认是否${e == "retreat" ? "退菜" : "赠菜"}`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            params.products.buyCount = 1;
            params.products.productSaleStatus = e == "retreat" ? 1 : 4;
            params.products = JSON.stringify([params.products]);
            this.operateOrder(params);
          })
          .catch(() => {});
      } else {
        this.$prompt(`请输入${e == "retreat" ? "退菜" : "赠菜"}数量`, "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputPattern: /\d+/,
          inputErrorMessage: "必须输入数字",
          inputPlaceholder: "请输入操作数量",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              if (instance.inputValue > 0) {
                done();
              } else {
                this.$notify({
                  title: "提示",
                  message: "数量必须大于0",
                  type: "error",
                  duration: 2000,
                });
              }
            } else {
              done();
            }
          },
        })
          .then(({ value }) => {
            params.products.buyCount = value;
            params.products.productSaleStatus = e == "retreat" ? 1 : 4;
            params.products = JSON.stringify([params.products]);
            this.operateOrder(params);
          })
          .catch(() => {});
      }
    },
    fullHandleEdit(e, index) {
      //整单操作
      params = {
        mallOrderId: this.orderList[index].mallOrderId,
      };
      if (e == "refund") {
        this.$confirm("确认整单退款吗？", "整单退款", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            params.fullOperateType = 1;
            this.operateOrder(params);
          })
          .catch(() => {});
      }
      if (e == "discount") {
        this.isShowDiscountPop = true;
        orderList = this.orderList[index];
      }
      if (e == "priceRevision") {
        this.$prompt("", "整单改价", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputPattern: /\d+/,
          inputErrorMessage: "必须输入数字",
          inputPlaceholder: "请输入修改后的价格",
        })
          .then(({ value }) => {
            params.fullOperateType = 3;
            params.customPrice = value;
            this.operateOrder(params);
          })
          .catch(() => {});
      }
    },
    toggleSelType(id) {
      if (!!~this.tagSelList.indexOf(id)) {
        this.tagSelList.splice(this.tagSelList.indexOf(id), 1);
      } else {
        this.tagSelList.push(id);
      }
    },
    discountConfirm() {
      if (!this.discount) {
        return this.$notify({
          title: "提示",
          message: "请填写折扣",
          type: "error",
          duration: 1000,
        });
      }
      if (!this.tagSelList.length) {
        return this.$notify({
          title: "提示",
          message: "请至少选择一个分类",
          type: "error",
          duration: 1000,
        });
      }
      let customPrice = 0;
      orderList.products.forEach((val) => {
        if (
          !!~this.tagSelList.indexOf(val.goodsCategoryId) &&
          val.productSaleStatus != 1 &&
          val.productSaleStatus != 4
        ) {
          customPrice += val.retailPrice * val.buyCount * this.discount;
        } else {
          if (val.productSaleStatus != 1 && val.productSaleStatus != 4) {
            customPrice += val.retailPrice * val.buyCount;
          }
        }
      });
      params.fullOperateType = 3;
      params.customPrice = customPrice.toFixed(2);
      this.isShowDiscountPop = false;
      this.operateOrder(params);
    },
    inputChangeLimitNum() {
      this.discount = this.discount.replace(/[^\d.]/g, "");
      this.discount = this.discount.replace(/\.{2,}/g, ".");
      this.discount = this.discount.replace(/^\./g, "0.");
      this.discount = this.discount.replace(
        /^\d*\.\d*\./g,
        this.discount.substring(0, this.discount.length - 1)
      );
      this.discount = this.discount.replace(/^0[^\.]+/g, "0");
      this.discount = this.discount.replace(/^[2-9]/g, "");
      this.discount = this.discount.replace(/^1[.*]/g, "1");
      this.discount = this.discount.replace(/^1[0-9]/g, "1");
      this.discount = this.discount.replace(/^(\d+)\.(\d\d).*$/, "$1.$2");
    },
    handleOrder(mallOrderId, orderStatus, payMoney, entryType) {
      let nextOrderStatus = 0;
      if (orderStatus == 10) {
        nextOrderStatus = -20;
      }
      if (orderStatus == 19) {
        nextOrderStatus = 20;
      }
      if (orderStatus == 20) {
        nextOrderStatus = 30;
      }
      if (orderStatus == 31) {
        nextOrderStatus = 40;
      }
      if (orderStatus == -22) {
        nextOrderStatus = -22;
      }
      if (orderStatus == -21 || orderStatus == 40) {
        nextOrderStatus = -50;
        // if (entryType != 3 && entryType != 4) {
        this.$prompt("请输入密码", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputType: "password",
        }).then(({ value }) => {
          console.log("请输入密码", value);
          if (!value) {
            return this.$notify({
              title: "提示",
              message: "请输入密码",
              type: "error",
              duration: 2000,
            });
          }
          createReundOrder({
            managerPassWord: String(md5(value)).toUpperCase(),
            mallOrderId: mallOrderId,
          }).then((res) => {
            if (res.code == 1) {
              this.$notify({
                title: "提示",
                message: "退款成功",
                type: "success",
                duration: 1000,
              });
              this.getPageData();
              this.getOrderNumsByStatus();
              if (this.isShowOrderDetails) {
                this.orderInfo(mallOrderId);
              }
            } else {
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "error",
                duration: 2000,
              });
            }
          });
        });
        return;
        // }
      }
      this.handleOrderFuc(mallOrderId, nextOrderStatus);
    },
    handleOrderFuc(mallOrderId, nextOrderStatus) {
      handleOrder({
        mallOrderId: mallOrderId,
        orderStatus: nextOrderStatus,
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "操作成功",
            type: "success",
            duration: 1000,
          });
          if (this.isShowOrderDetails) {
            this.orderInfo(mallOrderId);
          }
          this.getPageData();
          this.getOrderNumsByStatus();
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 1000,
          });
        }
      });
    },
    operateOrder(params) {
      operateOrder(params).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "操作成功",
            type: "success",
            duration: 1000,
          });
          this.getPageData();
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
      });
    },
    copyOrderNo(index) {
      var copyText = document.querySelector(`.order-no${index}`);
      copyText.select();
      document.execCommand("copy");
      this.$notify({
        title: "提示",
        message: "复制成功",
        type: "success",
        duration: 1000,
      });
    },
    printOrder(json) {
      if (!json.sex) {
        orderInfo({
          mallOrderId: json.mallOrderId,
          customParam: "headLogo,sex,cashierUserFullName",
        }).then((res) => {
          if (res.code == 1) {
            let data = res.data;
            this.printInfo = {
              tradeNo: data.tradeNo,
              supplementDateTime: json.supplementDateTime || json.createTime,
              createTime: data.createTime,
              printTime: new Date().pattern("yyyy-MM-dd HH:mm:ss"),
              buyerMark: data.buyerMark,
              shopMark: data.orderMark,
              products: data.products,
              payMoney: data.payMoney,
              memberName: data.memberName,
              buyerPhone: data.buyerPhone,
              memberWallet: data.memberWallet,
              memberScore: data.memberScore,
              totalRetailPrice: data.totalRetailPrice,
              shopPromotionTotalPrice: data.shopPromotionTotalPrice,
              shopPromotionDataList: data.shopPromotionDataList.length,
              payInterfacePartyType: data.payInterfacePartyType,
              payMoney: data.payMoney,
            };
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 2000,
            });
          }
          this.startPrint();
        });
      } else {
        this.printInfo = {
          tradeNo: json.tradeNo,
          createTime: json.createTime,
          printTime: new Date().pattern("yyyy-MM-dd HH:mm:ss"),
          buyerMark: json.buyerMark,
          shopMark: json.orderMark,
          products: json.products,
          payMoney: json.payMoney,
          memberName: json.memberName,
          memberCode: json.memberCode,
          buyerPhone: json.buyerPhone,
          memberWallet: json.memberWallet,
          memberScore: json.memberScore,
          totalRetailPrice: json.totalRetailPrice,
          shopPromotionTotalPrice: json.shopPromotionTotalPrice,
          shopPromotionDataList: json.shopPromotionDataList.length,
          payInterfacePartyType: json.payInterfacePartyType,
          payMoney: json.payMoney,
        };
        this.startPrint();
      }
    },
    startPrint() {
      setTimeout(() => {
        let style = `*{box-sizing:border-box}.temp-wrap{margin-left: -30px;}
          * {
            box-sizing: border-box;
            font-size: 12px;
          }
          .title {
            text-align: center;
            font-size: 20px;
          }
          .split-line {
            line-height: 25px;
          }
          .split-line .line {
            width: 25%;
            border-bottom: 1px dotted black;
            margin-top: -12.5px;
            display: inline-block;
            *display: block;
            *display: inline;
          }
          .split-line .words {
            width: 100%;
            display: inline-block;
            *display: block;
            *display: inline;
            text-align: center;
            font-size: 14px;
          }
          .two-columns .item {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            *display: block;
            *display: inline;
            -webkit-box-pack: justify;
            -ms-flex-pack: justify;
            justify-content: space-between;
            font-size: 12px;
            margin-bottom: 10px;
          }
          .two-columns .item span:first-child {
            min-width: 60px;
          }
          .two-columns .item span:last-child {
            word-break: break-all;
          }
          .ti-10 {
            text-indent: 10px;
          }
          .mg-10 {
            margin-bottom: 10px;
          }
          .font-bold {
            font-weight: bold;
          }
          #form1 {
            padding: 20px;
            width: 100%;
          }
          .goods {
            width: 100%;
          }
          .order-info {
            padding-top: 10px;
            border-top: 1px dotted black;
            border-bottom: 1px dotted black;
          }
          .shop-info {
            text-align: center;
            padding: 10px 0;
          }`;
        let basePath = "https://www.madiancan.com/";
        let templateHtml = `<!DOCTYPE html><html><head><meta charset='utf-8'/><style>html,body{height:100%;width:100%;margin:0;padding:0}${style}</style></head><body>${
          document.querySelector(".temp-main").innerHTML
        }</body></html>`;
        LODOP = getLodop();
        console.log(templateHtml);
        if (!LODOP) {
          if (confirm("打印机连接失败,查看解决方案？")) {
            window.location.href = basePath + "print/tip.html";
          } else {
            return;
          }
        }
        LODOP.PRINT_INIT("订单小票");
        LODOP.ADD_PRINT_HTM(0, 10, "100%", "100%", templateHtml);
        LODOP.SET_PRINT_COPIES(1); //设置打印份数
        LODOP.SET_PRINT_PAGESIZE(
          3,
          (localStorage.getItem("printWidth") || 58) * 10,
          40,
          ""
        );
        // LODOP.PREVIEW();
        LODOP.SET_PRINTER_INDEXA(LODOP.GET_PRINTER_NAME("-1"));
        LODOP.PRINT();
      }, 500);
    },
    getLogisticsInfo(sendType, mallOrderId) {
      if (sendType == 5) {
        getEleOrderShipDetail({
          mallOrderId,
        }).then((res) => {
          if (res.code == 1) {
            //   this.logisticsInfo = {
            //     info: {
            //       dmName: res.data.carrierInfo.carrier_driver_name,
            //       sendType: 3,
            //       dmMobile: res.data.carrierInfo.carrier_driver_phone,
            //     },
            //     status: [],
            //   };
            //   res.data.event_log_details.forEach((val) => {
            //     this.logisticsInfo.status.push({
            //       orderStatus: val.order_status,
            //       modifyTime: new Date(val.occur_time).pattern("HH:mm:ss"),
            //     });
            //   });
            this.logisticsInfo = {
              info: {
                dmName: res.data.eleInfo.courier_name,
                sendType: 5,
                dmMobile: res.data.eleInfo.courier_phone,
              },
              status: [],
            };
            res.data.status.forEach((val) => {
              this.logisticsInfo.status.push({
                orderStatus: val.orderStatus,
                modifyTime: new Date(val.modifyTime).pattern("HH:mm:ss"),
              });
            });
            this.isShowLogisticsInfo = true;
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 1000,
            });
          }
        });
      } else if (sendType == 6) {
        getDeliveryStatusLogMYT({
          originId: mallOrderId,
        }).then((res) => {
          if (res.code == 1) {
            //   this.logisticsInfo = {
            //     info: {
            //       dmName: res.data.carrierInfo.carrier_driver_name,
            //       sendType: 3,
            //       dmMobile: res.data.carrierInfo.carrier_driver_phone,
            //     },
            //     status: [],
            //   };
            //   res.data.event_log_details.forEach((val) => {
            //     this.logisticsInfo.status.push({
            //       orderStatus: val.order_status,
            //       modifyTime: new Date(val.occur_time).pattern("HH:mm:ss"),
            //     });
            //   });
            this.logisticsInfo = {
              info: {
                dmName: res.data.deliverys[0].rider_name,
                sendType: 6,
                dmMobile: res.data.deliverys[0].rider_phone,
              },
              status: [],
            };
            res.data.deliverys[0].logs.forEach((val) => {
              this.logisticsInfo.status.push({
                orderStatus: val.status,
                modifyTime: new Date(val.ctime).pattern("HH:mm:ss"),
              });
            });
            this.isShowLogisticsInfo = true;
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 1000,
            });
          }
        });
      } else {
        Promise.all([
          getDDOrderInfo({
            mallOrderId: mallOrderId,
          }),
          getDDlogistics({
            mallOrderId: mallOrderId,
          }),
        ]).then((res) => {
          console.log(res);
          if (res[0].code == 1) {
            res[0].data.sendType = sendType;
            this.logisticsInfo.info = res[0].data;
          } else {
            this.$notify({
              title: "警告",
              message: res[0].msg,
              type: "warning",
              duration: 2000,
            });
          }
          if (res[1].code == 1) {
            this.logisticsInfo.status = res[1].data;
          } else {
            this.$notify({
              title: "警告",
              message: res[1].msg,
              type: "warning",
              duration: 2000,
            });
          }
          this.isShowLogisticsInfo = true;
        });
      }
    },
    dadaCancelOrder() {
      cancelDadaOrder({
        mallOrderId: this.dadaOrderId,
        cancelReasonId: this.dadaReason,
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "取消配送成功",
            type: "success",
            duration: 2000,
          });
          this.getPageData();
          this.isShowDadaCancelReasons = false;
        } else {
          this.$notify({
            title: "警告",
            message: res.msg,
            type: "warning",
            duration: 2000,
          });
        }
      });
    },
    cancelOrder(sendType, orderId) {
      if (sendType == 2) {
        this.dadaOrderId = orderId;
        this.isShowDadaCancelReasons = true;
      }
      if (sendType == 4) {
        cancelShansongOrder({
          mallOrderId: orderId,
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "取消配送成功",
              type: "success",
              duration: 2000,
            });
            this.getPageData();
          } else {
            this.$notify({
              title: "警告",
              message: res.msg,
              type: "warning",
              duration: 2000,
            });
          }
        });
      }
      if (sendType == 5) {
        cancelEleOrder({
          mallOrderId: orderId,
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "取消配送成功",
              type: "success",
              duration: 2000,
            });
            this.getPageData();
          } else {
            this.$notify({
              title: "警告",
              message: res.msg,
              type: "warning",
              duration: 2000,
            });
          }
        });
      }
      if (sendType == 6) {
        orderCancelMYT({
          originId: orderId,
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "取消配送成功",
              type: "success",
              duration: 2000,
            });
            this.getPageData();
          } else {
            this.$notify({
              title: "警告",
              message: res.msg,
              type: "warning",
              duration: 2000,
            });
          }
        });
      }
    },
    showCargoWeightPop(itemInfo) {
      if (this.shopInfo.sendType == 5) {
        this.createEleOrder(itemInfo.mallOrderId);
      } else if (this.shopInfo.sendType == 6) {
        manualIssuance({
          originId: itemInfo.mallOrderId,
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "发货成功",
              type: "success",
              duration: 1000,
            });
            this.getPageData();
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 1000,
            });
          }
        });
      } else {
        this.isShowCargoWeightPop = true;
        this.distributionFee = 0;
        this.originId = itemInfo.mallOrderId;
        this.cargoWeight = "";
      }
    },
    cargoWeightInput() {
      this.cargoWeight = this.cargoWeight.replace(/[^\d.]/g, "");
      this.cargoWeight = this.cargoWeight.replace(/\.{2,}/g, ".");
      this.cargoWeight = this.cargoWeight.replace(/^\./g, "0.");
      this.cargoWeight = this.cargoWeight.replace(
        /^\d*\.\d*\./g,
        this.cargoWeight.substring(0, this.cargoWeight.length - 1)
      );
      this.cargoWeight = this.cargoWeight.replace(/^0[^\.]+/g, "0");
      clearTimeout(cargoWeightInputTimer);
      cargoWeightInputTimer = setTimeout(() => {
        this.isComputedFee = true;
        if (this.shopInfo.sendType == 2) {
          queryDDDeliverFee({
            originId: this.originId,
            cargoWeight: this.cargoWeight,
          }).then((res) => {
            if (res.code == 1) {
              this.distributionFee = res.data.fee;
            } else {
              this.$notify({
                title: "警告",
                message: res.msg,
                type: "warning",
                duration: 2000,
              });
            }
            this.isComputedFee = false;
          });
        }
        if (this.shopInfo.sendType == 4) {
          querySSDeliverFee({
            originId: this.originId,
            cargoWeight: this.cargoWeight,
          }).then((res) => {
            if (res.code == 1) {
              this.distributionFee = res.data.fee;
            } else {
              this.$notify({
                title: "警告",
                message: res.msg,
                type: "warning",
                duration: 2000,
              });
            }
            this.isComputedFee = false;
          });
        }
      }, 1000);
    },
    deliveryOrder() {
      if (!this.cargoWeight) {
        return this.$notify({
          title: "警告",
          message: "请输入斤两",
          type: "warning",
          duration: 2000,
        });
      }
      if (!this.distributionFee) {
        return this.$notify({
          title: "警告",
          message: "运费计算中，请稍等",
          type: "warning",
          duration: 2000,
        });
      }
      if (this.shopInfo.sendType == 2) {
        addDDAfterQuery({
          originId: this.originId,
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "发单成功",
              type: "success",
              duration: 2000,
            });
            this.isShowCargoWeightPop = false;
            this.getPageData();
          } else {
            this.$notify({
              title: "警告",
              message: res.msg,
              type: "warning",
              duration: 2000,
            });
          }
        });
      }
      if (this.shopInfo.sendType == 4) {
        addSSAfterQuery({
          originId: this.originId,
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "发单成功",
              type: "success",
              duration: 2000,
            });
            this.isShowCargoWeightPop = false;
            this.getPageData();
          } else {
            this.$notify({
              title: "警告",
              message: res.msg,
              type: "warning",
              duration: 2000,
            });
          }
        });
      }
    },
    orderInfo(mallOrderId) {
      orderInfo({
        mallOrderId,
        customParam: "headLogo,sex,cashierUserFullName",
      }).then((res) => {
        if (res.code == 1) {
          res.data.productsOem = [];
          res.data.products.forEach((proVal, proIndex) => {
            if (res.data.productsOem[proVal.groupId] == undefined) {
              res.data.productsOem[proVal.groupId] = [];
              res.data.productsOem[proVal.groupId].push(proVal);
            } else {
              res.data.productsOem[proVal.groupId].push(proVal);
            }
            if (proIndex == res.data.products.length - 1) {
              var r = res.data.productsOem.filter(function (s) {
                return s;
              });
              res.data.productsOem = r;
              res.data.productsOem.reverse();
            }
          });
          this.orderDetails = res.data;
          this.isShowOrderDetails = true;
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 1000,
          });
        }
      });
    },
    createEleOrder(mallOrderId) {
      createEleOrder({
        mallOrderId,
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "发货成功",
            type: "success",
            duration: 1000,
          });
          this.getPageData();
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 1000,
          });
        }
      });
    },
    saveMarksEdit() {
      setOrderAllMark({
        mallOrderId: this.orderDetails.mallOrderId,
        orderMark: this.orderDetails.orderMark,
        isOrderMark: 1,
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "修改成功",
            type: "success",
            duration: 2000,
          });
          this.isEditMarks = false;
        } else {
          this.$notify({
            title: "警告",
            message: res.msg,
            type: "warning",
            duration: 2000,
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.temp-main {
  display: none;
}
.content-page {
  .bd {
    height: 100%;
    overflow: hidden;
  }
  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
    font-size: 12px;
  }
  .tab-header {
    .top {
      display: flex;
      .top-item {
        display: flex;
        flex: 1;
        align-items: center;
        margin-right: 66px;
        span {
          white-space: nowrap;
          margin-right: 10px;
          font-size: 12px;
          color: #333333;
          font-weight: bold;
        }
        .el-select {
          width: 100%;
        }
      }
    }
  }
  .tab-content {
    display: block;
    padding: 20px;
    height: calc(100% - 63px);
    overflow: auto;
    .list {
      height: calc(100% - 76px);
      padding-bottom: 10px;
      box-sizing: border-box;
    }
    .order-list {
      height: calc(100% - 53px);
      overflow: auto;
      .item {
        border: 1px solid #eeeeee;
        margin-bottom: 20px;
        .list-header {
          background: #f8f8f8;
          height: 48px;
          line-height: 48px;
          padding: 0 18px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .order-num {
            font-size: 16px;
            color: #333333;
            font-weight: bold;
            margin-right: 10px;
          }
          .delivery-time {
            font-size: 12px;
            color: #f57878;
            margin-right: 10px;
          }
          .suggest,
          .order-no {
            font-size: 12px;
            color: #666666;
          }
          .suggest {
            margin-right: 28px;
          }
          .order-no {
            margin-right: 10px;
          }
        }
        .list-container {
          display: flex;
          & > div {
            border-right: 1px solid #eee;
            &:last-child {
              border-right: 0;
            }
          }
          .products {
            flex: 3.63;
            & > div:last-of-type {
              & > .products-item:last-of-type {
                border-bottom: 0;
              }
            }
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;
            & > div {
              width: 100%;
              flex: 1;
              display: flex;
              flex-direction: column;
            }
            .products-item {
              display: flex;
              height: 70px;
              box-sizing: border-box;
              align-items: center;
              border-bottom: 1px solid #eee;
              flex: 1;
              .info {
                flex: 5.3;
                display: flex;
                align-items: center;
                .no-img {
                  margin: 0 auto;
                }
                img {
                  width: 50px;
                  height: 50px;
                  margin: 0 10px 0 18px;
                }
                .price {
                  font-size: 12px;
                  line-height: 26px;
                  color: #666666;
                }
                .name {
                  font-size: 12px;
                  line-height: 28px;
                  color: #333333;
                  font-weight: bold;
                  white-space: nowrap;
                  max-width: 130px;
                  text-overflow: ellipsis;
                  overflow: hidden;
                }
                .desc {
                  font-size: 12px;
                  line-height: 16px;
                  color: #666;
                  font-weight: bold;
                  white-space: nowrap;
                  max-width: 130px;
                  text-overflow: ellipsis;
                  overflow: hidden;
                }
              }
              .num {
                flex: 1.46;
                font-size: 12px;
                color: #333333;
                font-weight: bold;
                .num-type {
                  display: inline-block;
                  border: 1px solid;
                  border-radius: 4px;
                  text-align: center;
                  font-size: 12px;
                  line-height: 22px;
                  box-sizing: border-box;
                  width: 36px;
                  height: 24px;
                  &.retreat {
                    border-color: #fde2e2;
                    background-color: #fef0f0;
                    color: #f57878;
                  }
                  &.give {
                    border-color: #faecd8;
                    background-color: #fdf6ec;
                    color: #e6a45d;
                  }
                }
              }
              .price {
                flex: 2.11;
                width: 130px;
                font-size: 12px;
                color: #666666;
              }
              .action {
                flex: 1.11;
              }
              .worker {
                flex: 1.5;
              }
            }
          }
          .time {
            flex: 0.87;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            & > div {
              display: flex;
              align-items: center;
              flex: 1;
              border-bottom: 1px solid #eeeeee;
              width: 100%;
              justify-content: center;
              &:last-child {
                border-bottom: 0;
              }
              .time-item {
                font-size: 12px;
                color: #999999;
                line-height: 22px;
              }
            }
          }
          & > .info {
            position: relative;
            flex: 1.95;
            padding: 32px 10px 0 15px;
            font-size: 14px;
            line-height: 1;
            .takeoutinfo {
              margin-bottom: 14px;
            }
            .address {
              margin-bottom: 10px;
            }
            .tanginfo {
              color: #333333;
              .position {
                font-weight: bold;
              }
              margin-bottom: 20px;
            }
            .mark {
              color: #ee3030;
            }
            .icon-img {
              position: absolute;
              right: 10px;
              top: 10px;
            }
          }
          & > .price {
            flex: 1.58;
            text-align: center;
            padding-top: 31px;
            padding-bottom: 20px;
            line-height: 1;
            font-size: 14px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            & > p.total-price,
            .price-msg {
              color: #333333;
              font-weight: bold;
              margin-bottom: 15px;
            }
            & > p.food-box-price {
              font-size: 12px;
              color: #999999;
              margin-bottom: 12px;
            }
            & > p.gain-money {
              color: #ee3030;
              margin-bottom: 20px;
            }
          }
          .action {
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            padding-top: 30px;
            padding-bottom: 20px;
            flex: 1;
            & > p:nth-of-type(1) {
              font-size: 14px;
              font-weight: bold;
              &.red {
                color: #ee3030;
              }
              &.black {
                color: #000;
              }
            }
            .reason {
              color: #e6a23c;
            }
            & > .el-button--primary {
              margin-top: 15px;
            }
            .el-button + .el-button {
              &.create-btn {
                display: block;
                margin-left: 0;
                margin: 10px auto 0;
              }
              margin-left: 2px;
            }
            .status-btn {
              display: block;
              margin-left: 0;
              margin: 10px auto 0;
            }
          }
          .print {
            text-align: center;
            padding-top: 20px;
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .el-button {
              margin: 0 0 10px 0;
            }
            .check-logistics {
              display: block;
              margin: 10px auto 0;
            }
          }
        }
      }
    }
    .list-none {
      text-align: center;
      font-size: 14px;
      color: #999999;
      padding-top: 20px;
    }
  }
  .el-dialog {
    .el-select {
      width: 100%;
    }
  }
  .tag-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 20px 0;
    .tag {
      width: 90px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      background: url(../assets/img/order/bg-unsel.png) no-repeat top left/ 100% 100%;
      margin: 10px 0;
      cursor: pointer;
      &.sel {
        background: url(../assets/img/order/bg-sel.png) no-repeat top left/ 100% 100%;
      }
    }
  }
  .logistics-dialog {
    .logistics-header {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      border-radius: 6px;
      background: #f6fbff;
      padding: 14px 10px;
      .icon {
        width: 46px;
        height: 46px;
        margin-right: 10px;
      }
      .info {
        font-size: 12px;
        color: #409eff;
        line-height: 1;
        .name {
          margin-bottom: 8px;
          .tag {
            display: inline-block;
            padding: 3px 6px;
            background: #409eff;
            border-radius: 20px;
            border-bottom-left-radius: 0;
            font-size: 12px;
            line-height: 1;
            color: #fff;
            margin-left: 6px;
          }
        }
      }
    }
    .logistics-body {
      min-height: 500px;
      max-height: 500px;
      overflow: auto;
      margin-top: 22px;
      .el-steps-oem {
        padding: 10px;
        .el-step-oem {
          position: relative;
          padding-left: 40px;
          padding-bottom: 34px;
          &.active {
            &:not(:last-child)::before {
              background: #409eff;
            }
            .index {
              border-color: #409eff;
              color: #409eff;
            }
          }
          &:not(:last-child)::before {
            position: absolute;
            content: "";
            top: 0;
            bottom: 0;
            left: 12px;
            width: 2px;
            background: #c0c4cc;
          }
          .index {
            position: absolute;
            border: 2px solid #c0c4cc;
            height: 24px;
            width: 24px;
            line-height: 24px;
            text-align: center;
            font-size: 14px;
            color: #c0c4cc;
            left: 0;
            top: -5px;
            border-radius: 50%;
            background: #fff;
            font-weight: bold;
          }
          .desc,
          .time {
            font-size: 12px;
            color: #666666;
          }
          .title {
            font-size: 16px;
            color: #333333;
            font-weight: bold;
            position: relative;
            top: -5px;
            &.active {
              color: #409eff;
            }
          }
        }
      }
    }
  }
  .dialog-row {
    line-height: 50px;
    font-size: 18px;
    padding: 0 10px;
  }
  .popup {
    z-index: 1000;
  }
  .write-off {
    .popup-container {
      width: 300px;
      height: 280px;
      text-align: center;
    }
    .scan-pay {
      .img-scan,
      .scan-code-img {
        width: 200px;
        height: 200px;
      }
      .tips {
        height: 28px;
        font-size: 16px;
        line-height: 28px;
        margin: 16px 0 32px;
        color: #969799;
      }
    }
  }
  .popup-container {
    width: 1000px;
    height: 600px;
    .order-details {
      padding: 20px;
      height: 550px;
      overflow-y: auto;
      box-sizing: border-box;
      .inline-block-title {
        background: #f8f8f8;
        padding-left: 20px;
        line-height: 40px;
        font-size: 14px;
        position: relative;
        &:before {
          content: " ";
          display: block;
          width: 4px;
          height: 20px;
          background: #66b1ff;
          position: absolute;
          left: 10px;
          top: 50%;
          transform: translateY(-50%);
        }
      }
      .order-info {
        .marks {
          padding: 10px 5px;
          margin-top: 10px;
          background: rgb(240, 229, 165);
        }
        .el-button {
          margin-top: 10px;
        }
        .status {
          font-size: 26px;
          line-height: 50px;
        }
      }
      .buyer-info {
        .buyer-details {
          display: flex;
          align-items: center;
          .buyer-avatar {
            width: 30px;
            height: 30px;
            border-radius: 100%;
            margin-right: 10px;
          }
          .buyer-nickname {
            font-size: 26px;
            line-height: 50px;
          }
        }
      }
      .consume-info {
        .service-info {
          padding: 20px;
        }
        .table {
          border: 1px solid #eee;
          .table-header {
            display: flex;
            background: #f8f8f8;
            line-height: 50px;
            font-size: 16px;
            padding: 0 10px;
          }
          .item {
            display: flex;
            line-height: 50px;
            padding: 10px;
            border-bottom: 1px solid #eee;
            .service-details {
              line-height: 25px;
            }
            .name {
              display: flex;
              .service-img {
                width: 50px;
                height: 50px;
                border-radius: 50%;
                margin-right: 10px;
              }
              .service-name {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                width: 200px;
              }
            }
          }
          .name {
            flex: 3;
          }
          .price,
          .num,
          .work,
          .sale,
          .promotion,
          .subtotal {
            flex: 1;
          }
          .total {
            text-align: right;
            line-height: 30px;
            font-size: 16px;
            padding: 10px;
            span {
              display: inline-block;
            }
            .title {
              width: 150px;
              text-align: left;
            }
            .price {
              width: 150px;
              text-align: right;
            }
          }
        }
      }
      .content {
        padding: 10px 20px;
        .item {
          line-height: 30px;
          p {
            display: inline-block;
            width: 40%;
            span {
              display: inline-block;
              color: #aaa;
              width: 60px;
              margin-right: 10px;
              vertical-align: top;
            }
          }
        }
      }
    }
    .action {
      padding: 0 20px;
      height: 50px;
      display: flex;
      align-items: center;
      border-top: 1px solid #eee;
      justify-content: flex-end;
      box-sizing: border-box;
    }
  }
  .disable-event {
    pointer-events: none;
    overflow: none;
  }
}
</style>

<style lang="less">
.el-transfer-panel__item {
  display: block;
}
.el-select-dropdown {
  width: 150px;
}
</style>
